import { Button, Checkbox, ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { CustomDropDown } from 'common'

// Imports custom
import { FileManagerList } from 'common'
import { TooltipInformation } from 'common'
import { DollarSign, Edit3, Trash2 } from 'react-feather'

export const VehicleExpensesTable = ({ useFetchInit }) => {

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    const { fetchVehicleExpenses: { vehicleExpenses } } = FetchData

    const { handleClickDeleteVehicleExpense, handleClickEditExpense, handleChangeCheckBox, handleClickShowModal } = Actions

    const cellRendererTooltip = (params) => {
        //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
        const { idexpense, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
        return (
            <>
                <TooltipInformation
                    idregistro={idexpense}
                    usuario_creo={usuario_creo}
                    fecha_creo={fecha_creo}
                    usuario_modifico={usuario_modifico}
                    fecha_modifico={fecha_modifico}
                />
            </>

        )
    }

    const cellRendererCheckbox = (params) => {
        const { check_print, idexpense } = params.data

        return (
            <Checkbox
                checked={check_print}
                onChange={(event) => handleChangeCheckBox(event, idexpense)}
                color="primary"
            />
        )
    }

    const cellRendererOptions = (params) => {

        const { idexpense } = params.data

        return (
            < CustomDropDown>
                <MenuItem
                    onClick={() => handleClickEditExpense(idexpense)}
                >
                    <ListItemIcon> <Edit3 color="black" /> </ListItemIcon>
                    <ListItemText primary="Editar" />
                </MenuItem>
                <MenuItem
                    onClick={() => handleClickDeleteVehicleExpense(idexpense)}
                >
                    <ListItemIcon> <Trash2 color="black" /> </ListItemIcon>
                    <ListItemText primary="Eliminar" />
                </MenuItem>
                <MenuItem
                    onClick={() => handleClickShowModal('', 'Anticipos', 'advance-section', { idexpense }, 'EDITABLE')}
                >
                    <ListItemIcon> <DollarSign color="black" /> </ListItemIcon>
                    <ListItemText primary="Anticipos" />
                </MenuItem>
            </CustomDropDown >
        )
    }

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: "INFO",
            minWidth: 120,
            maxWidth: 120,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: cellRendererTooltip
        },
        {
            //FIELD PARA CHECKBOX SELECCIÓN
            headerName: "IMPRIMIR",
            minWidth: 120,
            maxWidth: 120,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: cellRendererCheckbox
        },
        { field: "title", headerName: "GASTO", minWidth: 300, filter: true },
        { field: "supplier", headerName: "PROVEEDOR", minWidth: 340, filter: true },
        { field: "advance", headerName: "ANTICIPO INICIAL", minWidth: 120, filter: true },
        { field: "total_advances", headerName: "ANTICIPO TOTAL", minWidth: 120, filter: true },
        { field: "expense", headerName: "TOTAL", minWidth: 120, filter: true },
        {
            headerName: "OPCIONES", minWidth: 200,
            cellRenderer: cellRendererOptions
        },
    ]


    return (
        //ESTRUCTURA PARA INCLUIR CAJA DE BUSQUEDA
        <div className='content'>
            <FileManagerList
                rowConfig={vehicleExpenses}
                // rowConfig={[]}
                columnConfig={columnConfig}
            />
        </div>
    )

}